<template>
    <div class="login">
        <div class="login-title"><span>{{title}}</span></div>
        <div class="login-img"></div>
        <!--<img src="../../../assets/images/login-smx.png">-->
        <div class="login-con">
            <Card icon="log-in" title="欢迎登录" :bordered="false" :padding="30">
                <div slot="title" class="my-title">
                    欢迎登录
                </div>
                <div class="form-con">
                    <login-form @on-success-valid="handleSubmit"></login-form>
                    <p class="login-tip"></p>
                </div>
            </Card>
        </div>
        <div style="" class="beian">
            <a href="https://beian.miit.gov.cn" target="_blank">豫ICP备19046586号-1</a>
        </div>
    </div>
</template>

<script>
    import LoginForm from './login-form'
    import iProperties from '@/module/base/api/iProperties'

    export default {
        components: {
            LoginForm
        },
        data() {
            return {
                title:'非道路机械监管平台'
            }
        },
        mounted() {
            iProperties.sysName().then(res => {
                if(res){
                    this.title = res
                    document.title = res
                }
            });
        },
        methods: {
            handleSubmit({userName, password}) {
                this.$store.dispatch('Login', {userName, password}).then(() => {
                    this.$router.push({path: '/'});
                });
            }
        }
    }
</script>

<style lang="less" scoped>
    .beian{
        position: absolute;
        bottom: 0;
        width: 100%;
        background: #fff;
        text-align: center;
        height: 36px;
        font-size: 18px;
        padding-right: 10px;
        line-height: 36px;
        a{
            color: #333333;
        }
    }
    .login {
        width: 100%;
        height: 100%;
        background: url('../../../assets/images/login-bg.jpg') no-repeat center top;
        background-size: cover;
        background-position: center top;
        position: relative;

        .login-title{
            overflow: hidden;
            line-height: 50px;
            font-size: 17px;
            padding-top: 50px;
            text-align: center;

            span{
                color: #fff;
                font-size: 40px;
                font-weight: bold;
                text-shadow: 0px 0px 10px rgba(0,0,0,0.3);
                letter-spacing: 5px;
            }
        }

        .login-img {
            width: 600px;
            height: 424px;
            background: url(../../../assets/images/login-font.png) no-repeat center;
            position: absolute;
            left: 50%;
            top: 50%;
            margin-top: -212px;
            margin-left: -600px;
            background-size: 100% 100%;
        }

        &-con {
            position: absolute;
            right: 160px;
            top: 50%;
            transform: translateY(-60%);
            width: 380px;

            .my-title{
                padding-left:14px;
                font-size:22px;
                line-height:28px;
                font-weight:400;
            }

            &-header {
                font-size: 16px;
                font-weight: 300;
                text-align: center;
                padding: 30px 0;
            }

            .form-con {
                padding: 0;
            }

            .login-tip {
                font-size: 10px;
                text-align: center;
                color: #c3c3c3;
            }
        }
    }

</style>
